import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd8dfd80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer remove-mix-blend-mode" }
const _hoisted_2 = { class: "footer_container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__michelin" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.nederlandsmijnmuseum.nl/wp-content/themes/NMM/img/Sticker GV_2026_EN - 1 star.png",
    alt: "Michelin 1 Star",
    class: "footer__michelin_star"
  })
], -1))
const _hoisted_4 = { class: "footer_column" }
const _hoisted_5 = { class: "footer__address" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "footer_column footer_column--links" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Direct naar", -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "footer_column footer_column--links" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin":"0"} }, "Nieuwsbrief", -1))
const _hoisted_13 = { class: "footer_column footer_column--socials" }
const _hoisted_14 = { class: "footer__social_links" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_NewsletterForm = _resolveComponent("NewsletterForm")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Logo, { class: "footer__logo" }),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", null, null, 512), [
            [_directive_sanitize, _ctx.address]
          ]),
          _createElementVNode("a", {
            href: `tel:${_ctx.phonelink}`,
            class: "footer__contact_link footer__contact_link--telephone"
          }, _toDisplayString(_ctx.phone), 9, _hoisted_6),
          _createElementVNode("a", {
            href: `mailto:${_ctx.email}`,
            class: "footer__contact_link footer__contact_link--mail"
          }, _toDisplayString(_ctx.email), 9, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkColumn2, (link, index) => {
          return (_openBlock(), _createElementBlock("a", {
            class: "footer__navigation_link",
            key: `footerlink-${link.href}-${index}`,
            href: link.href
          }, [
            _createTextVNode(_toDisplayString(link.label) + " ", 1),
            _createVNode(_component_Icon, {
              type: "arrow-right",
              class: "button__arrow"
            })
          ], 8, _hoisted_10))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_NewsletterForm)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_ctx.socialmedia && _ctx.socialmedia.facebook)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.socialmedia.facebook,
                target: "_blank",
                class: "footer__social_link"
              }, [
                _createVNode(_component_Icon, { type: "facebook" })
              ], 8, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.socialmedia && _ctx.socialmedia.linkedin)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.socialmedia.linkedin,
                target: "_blank",
                class: "footer__social_link"
              }, [
                _createVNode(_component_Icon, { type: "linkedin" })
              ], 8, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.socialmedia && _ctx.socialmedia.twitter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.socialmedia.twitter,
                target: "_blank",
                class: "footer__social_link"
              }, [
                _createVNode(_component_Icon, { type: "twitter" })
              ], 8, _hoisted_17))
            : _createCommentVNode("", true),
          (_ctx.socialmedia && _ctx.socialmedia.instagram)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: _ctx.socialmedia.instagram,
                target: "_blank",
                class: "footer__social_link"
              }, [
                _createVNode(_component_Icon, { type: "instagram" })
              ], 8, _hoisted_18))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}